module.exports = __webpack_public_path__ + "static/google-play-qr-4135b124b96eb0ed0a8dcecd631ec23e.svg";